<div class="menu-secondary-actions">
  <button type="button" class="close-menu-btn btn btn-link" (click)="closeAltMenu()">
    <i class="fas fa-arrow-left"></i>
  </button>
  <div class="menu-search">
    <input class="search-input form-control form-control" type="text" placeholder="Search">
  </div>
</div>
